import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactTable from 'react-table'

class CustomTable extends Component {
  static propTypes = {
    columns: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    noDataText: PropTypes.string,
  }

  render() {
    const { columns, data, noDataText } = this.props
    return (
      <ReactTable
        filterable
        className="-striped -highlight"
        columns={columns}
        defaultPageSize={10}
        data={data}
        noDataText={noDataText}
      />
    )
  }
}

export default CustomTable



// WEBPACK FOOTER //
// ./src/components/ui/lists/CustomTable.js